import cart from './cartReducer.ts';
import header from './headerReducer.ts';
import { appBannerReducer } from './appBannerReducer.js';
import { drawerReducer } from './drawerReducer.ts';

export default {
    cart,
    appBanner: appBannerReducer,
    drawer: drawerReducer,
    header,
};
